async function AddJunction(userid, designid, junction) {

    if (
        userid.length > 0 &&
        designid.length > 0
    ) {

        let response;

        let params = JSON.stringify(
            {
                "userID": userid,
                "designID": designid,
                "junc": junction
            }
        )

        response = await fetch("https://api.cssi.co/CNF/AddJunction", {
            method: "POST",
            body: params
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })
        return Promise.resolve(response);
    }
}

export default AddJunction;